'use strict';

/* global $ */
/* global _ */
/* Backbone */
/* Marionette */

import { getAjax } from '../utils/ajax';
import { CalculatorTimberModel, CalculatorTimber } from './calculator/timber';
import { CalculatorBarModel, CalculatorBar } from './calculator/bar';
import { CalculatorUnedgedModel, CalculatorUnedged } from './calculator/unedged';
import { CalculatorPanelModel, CalculatorPanel } from './calculator/panel';
import { CalculatorCanopyModel, CalculatorCanopy } from './calculator/canopy';
import { CalculatorBlockModel, CalculatorBlock } from './calculator/block';
import { CalculatorDeckModel, CalculatorDeck } from './calculator/deck';

class CalculatorFactory {
    static getCalculator(el) {
        el.addClass('is-pre-loading');
        getAjax({
            _do: 'get_calculator',
            calculator_id: el.data('calculatorId'),
            result : 'json'
        },  {
            url: '/oa/'
        })
        .then(function (response) {
            el.removeClass('is-pre-loading');
            let view = CalculatorFactory.createCalculator(el, response.data);
            view.render();
        })
        .catch(function (error) {
            el.removeClass('is-pre-loading');
            console.log(error);
        });
    }
    static createCalculator(el, data) {
        if(data){
            let calculatorType = data.calculator.type;
            if(calculatorType){
                switch (calculatorType) {
                case 'timber':
                    return new CalculatorTimber({
                        model: new CalculatorTimberModel(data.calculator),
                        el: el,
                        input_params: data.calculator.input_params || []
                    });
                case 'unedged':
                    data.calculator.type = 'timber';
                    return new CalculatorUnedged({
                        model: new CalculatorUnedgedModel(data.calculator),
                        el: el,
                        input_params: data.calculator.input_params || []
                    });
                case 'bar':
                    return new CalculatorBar({
                        model: new CalculatorBarModel(data.calculator),
                        el: el,
                        input_params: data.calculator.input_params || []
                    });
                case 'canopy':
                    data.calculator.type = 'bar';
                    return new CalculatorCanopy({
                        model: new CalculatorCanopyModel(data.calculator),
                        el: el,
                        input_params: data.calculator.input_params || []
                    });
                case 'panel':
                    return new CalculatorPanel({
                        model: new CalculatorPanelModel(data.calculator),
                        el: el,
                        input_params: data.calculator.input_params || [],
                        calc_params: data.calculator.params_calc || {}
                    });
                case 'deck':
                    data.calculator.type = 'panel';
                    return new CalculatorDeck({
                        model: new CalculatorDeckModel(data.calculator),
                        el: el,
                        input_params: data.calculator.input_params || [],
                        calc_params: data.calculator.params_calc || {}
                    });
                case 'block':
                    data.calculator.type = 'panel';
                    return new CalculatorBlock({
                        model: new CalculatorBlockModel(data.calculator),
                        el: el,
                        input_params: data.calculator.input_params || [],
                        calc_params: data.calculator.params_calc || {}
                    });
                default:
                    throw new Error('Обработчик для типа калькулятора '+calculatorType+' не найден');
                }
            }
        }
    }
}

function CalculatorInit (options) {
    var opt = _.merge({ }, {
        calculator: '.js-calculator',
    }, options);

    let $calculators = $(opt.calculator);
    if($calculators.length > 0){
        let i = 0;
        while(i < $calculators.length){
            let $item = $calculators.eq(i);

            CalculatorFactory.getCalculator($item);

            i++;
        }
    }

}

export {
    CalculatorInit
};

